module.exports = __webpack_public_path__ + "static/media/logo-peintegrado.eb2cc72f.png";